"use client";

import dynamic from "next/dynamic";

const AccordionItemsSingleExpandLazy = dynamic(() => import("./AccordionitemsSingleExpand"));

export default AccordionItemsSingleExpandLazy;
